import jwt from 'jsonwebtoken';
import { cookiesHelper } from 'modules/utils';

export const decodeLavuToken = () => {
	const lavuToken = cookiesHelper.get('LAVU_TOKEN');
	const user = jwt.decode(lavuToken);

	return user;
};
